import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-history';
const BASE_URL_V3 = 'api/v3/rpm-history';

export default {
  // API Version 2
  getLogs: (patientId, params) => api.get(`${BASE_URL_V2}/activity-log/${patientId}`, { params }),
  printActivityLog: (patientId, params) => api.get(`${BASE_URL_V2}/activity-log/print-pdf/${patientId}`, { responseType: 'blob', params }),
  startTimeTracking: params => api.post(`${BASE_URL_V2}/time-tracking`, params),
  stopTimeTracking: params => api.put(`${BASE_URL_V2}/time-tracking`, params),
  getTimeTracking: params => api.get(`${BASE_URL_V2}/time-tracking`, { params }),
  getPatientNotes: (patientId, params) => api.get(`${BASE_URL_V2}/notes/${patientId}`, { params }),
  addPatientNote: (patientId, params) => api.post(`${BASE_URL_V2}/notes/${patientId}`, params),
  // API Version 3
  getHistory: (patientId, params) => api.get(`${BASE_URL_V3}/measure-history/${patientId}`, { params }),
  getPackagesForManual: params => api.get(`${BASE_URL_V3}/measure-history/manual`, { params }),
  setRpmMeasureManyally: params => api.post(`${BASE_URL_V3}/measure-history/manual`, params),

};
